import { render, staticRenderFns } from "./StudentOrder.vue?vue&type=template&id=53de9286&scoped=true"
import script from "./StudentOrder.vue?vue&type=script&lang=js"
export * from "./StudentOrder.vue?vue&type=script&lang=js"
import style0 from "./StudentOrder.vue?vue&type=style&index=0&id=53de9286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de9286",
  null
  
)

export default component.exports